import { startOfWeek, endOfWeek, startOfMonth, endOfMonth } from "date-fns";
import { createStaticRanges } from "react-date-range";
import { ECalendarRange } from "./types";

export const defineds = {
  startOfWeek: startOfWeek(new Date(), { weekStartsOn: 1 }),
  endOfWeek: endOfWeek(new Date(), { weekStartsOn: 1 }),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
};

export const getCalendarRanges = () => {
  return {
    [ECalendarRange.TODAY]: {
      label: "Сегодня",
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
    },
    [ECalendarRange.WEEK]: {
      label: "Эта неделя",
      range: () => ({
        startDate: defineds.startOfWeek,
        endDate: defineds.endOfWeek,
      }),
    },
    [ECalendarRange.MONTH]: {
      label: "Этот месяц",
      range: () => ({
        startDate: defineds.startOfMonth,
        endDate: defineds.endOfMonth,
      }),
    },
  };
};

export const getStaticRanges = () =>
  createStaticRanges(Object.values(getCalendarRanges()));
